module.exports = __webpack_public_path__ + "static/media/m-ecomerce-img.283aa624.png";